export default (event, { getProps }) => {
    const { jumpToFirstCell } = getProps();

    event.preventDefault();
    event.stopPropagation();

    jumpToFirstCell && jumpToFirstCell();
};
